import { styled } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import { HighlightColorVariantEnum } from '../../../Highlighting/types';
import { getHighlightRGBA } from '../../../Highlighting/utils/utils';

interface ColorInputIconProps {
  colorName: string;
  borderRadius: string;
}

export function UncheckedColorInputIcon({
  colorName,
  borderRadius,
}: Readonly<ColorInputIconProps>) {
  const StyledIcon = styled('span')<{
    bgcolor: string;
  }>(({ theme, bgcolor }) => ({
    borderRadius,
    width: 24,
    height: 24,
    backgroundColor: bgcolor,
    boxShadow: `inset 0 0 0 1px ${theme.palette.divider}, inset 0 -1px 0 ${theme.palette.divider}`,
    'input:hover ~ &': {
      backgroundImage: `linear-gradient(${theme.palette.divider}, ${theme.palette.divider})`,
    },
  }));
  return (
    <StyledIcon
      bgcolor={getHighlightRGBA(
        colorName,
        HighlightColorVariantEnum.backgroundColor,
      )}
    />
  );
}

export function CheckedColorInputIcon({
  colorName,
  borderRadius,
}: Readonly<ColorInputIconProps>) {
  const StyledCheckedIcon = styled(CheckIcon)<{
    bgcolor: string;
  }>(({ theme, bgcolor }) => ({
    borderRadius,
    backgroundColor: bgcolor,
    color: theme.palette.action.active,
    width: 24,
    height: 24,
    padding: 4,
    boxShadow: `inset 0 0 0 1px ${theme.palette.divider}, inset 0 -1px 0 ${theme.palette.divider}`,
    'input:hover ~ &': {
      backgroundImage: `linear-gradient(${theme.palette.divider}, ${theme.palette.divider})`,
    },
  }));
  return (
    <StyledCheckedIcon
      bgcolor={getHighlightRGBA(
        colorName,
        HighlightColorVariantEnum.backgroundColor,
      )}
    />
  );
}

export type { ColorInputIconProps };
